import React from 'react';

const SearchBox = ({ searchTerm, setSearchTerm, navigate }) => (
    <div style={styles.row}>
        <div style={styles.searchWrapper}>
            <i className="bi bi-search" style={styles.searchIcon}></i>
            <input
                type="text"
                placeholder="Search by group name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={styles.searchInput}
            />
        </div>
        <button style={styles.btnPrimary} onClick={() => navigate('/createContactGroup')}>
            <i className="bi bi-plus-lg" style={{ marginRight: 6 }}></i>
            Add Contact Group
        </button>
    </div>
);

const styles = {
    row: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap' },
    searchWrapper: { position: 'relative', flex: 1, maxWidth: '360px' },
    searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '14px' },
    searchInput: { width: '100%', padding: '9px 12px 9px 36px', fontSize: '14px', border: '1.5px solid #e5e7eb', borderRadius: '8px', outline: 'none', boxSizing: 'border-box', color: '#111827' },
    btnPrimary: { display: 'inline-flex', alignItems: 'center', padding: '8px 16px', background: 'linear-gradient(to right, #2388e0, #1565c0)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' },
};

export default SearchBox;
